export const eventFilterKeys = ['city', 'event_type', 'language', 'price'] as const;
export const pServiceFilterKeys = ['city', 'language'] as const;
export type EventFilterKey = (typeof eventFilterKeys)[number];
export type PServiceFilterKey = (typeof pServiceFilterKeys)[number];

export type FilterKeys = EventFilterKey | PServiceFilterKey;

export interface FilterItem {
    key: FilterKeys;
    value: number | string;
    display: string;
    isSelected?: boolean;
}

export interface PServiceFilterItem {
    key: PServiceFilterKey;
    value: number | string;
    display: string;
    isSelected?: boolean;
}

export type FilterPriceValues = 'paid' | 'free';
export type FilterPriceType = Array<FilterPriceValues>;
